import { GridWrapper } from '../../StoreHomePage/BannersGrid/styled';
import {
  MostReadArticle,
  SimilarVideoTitle,
} from '../ArticlesAndVideos/styled';
import RecentArticleCard from './RecentArticleCard';
import RecentArticleList from './RecentArticleList';
import { RecentArticleContainer, RecentArticlesList } from './styled';

export default function RecentlyAddedArticlesCover(props) {
  const { recentArticles, heading, subHeading, location } = props;
  const recentArticlesCopy = [...recentArticles];
  const indexToSplit = 6;
  const cardarray = recentArticlesCopy.slice(0, indexToSplit);
  const listArray = recentArticlesCopy.slice(indexToSplit);
  return (
    <GridWrapper clinicExpert={location == 'article' ? true : false}>
      <div>
        <SimilarVideoTitle>
          {heading ? heading : 'RECENTLY PUBLISHED ARTICLES'}
        </SimilarVideoTitle>
        <MostReadArticle>
          {subHeading ? subHeading : 'our most recent articles'}
        </MostReadArticle>
      </div>
      <RecentArticleContainer>
        {cardarray?.map((data, index) => {
          return (
            <RecentArticleCard
              primaryTagId={data?.primary_tag_id}
              index={index}
              cardData={data?.content?.content || data?.content}
              contentType={data?.content_type}
              heading={data?.heading}
              key={index}
            />
          );
        })}
      </RecentArticleContainer>
      <RecentArticlesList>
        {listArray?.map((data, index) => {
          return (
            <RecentArticleList index={index} data={data} key={`list${index}`} />
          );
        })}
      </RecentArticlesList>
    </GridWrapper>
  );
}
